<template>

  <t-page>

    <t-page-general :current-page="currentPage" :user-auth="userAuth">

      <div class="grid-menu grid-menu-2col" v-if="accountModule === 'production'">
        <div class="no-gutters row">

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="product-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-family')"
                      to="product-family">
              <i class="lnr-menu-circle btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Família de Produtos
            </t-button>
          </div>
          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-tolerance')"
                      to="product-tolerance">
              <i class="lnr-line-spacing btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Tolerâncias
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-raw-material')"
                      to="product-raw-material">
              <i class="lnr-leaf btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Matérias-Prima
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-component')"
                      to="product-component">
              <i class="lnr-paperclip btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Componentes
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-unit')"
                      to="product-unit">
              <i class="lnr-spell-check btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Unidades de Medidas
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-market-code')"
                      to="product-market-code">
              <i class="lnr-tag btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Códigos de Conversão
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-feature')"
                      to="product-feature">
              <i class="lnr-select btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Características
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-complement')"
                      to="product-complement">
              <i class="lnr-text-format btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Acabamentos
            </t-button>
          </div>


        </div>
      </div>


      <div class="grid-menu grid-menu-2col" v-if="accountModule === 'arch'">
        <div class="no-gutters row">

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessSubValidation('sub-general-setting-param')"
                      to="product-setting-param">
              <i class="lnr-list btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Parâmetros
            </t-button>
          </div>

<!--          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-family')"
                      to="product-family">
              <i class="lnr-menu-circle btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Família de Produtos
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-unit')"
                      to="product-unit">
              <i class="lnr-spell-check btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Unidades de Medidas
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-market-code')"
                      to="product-market-code">
              <i class="lnr-tag btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Códigos de Conversão
            </t-button>
          </div>


          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-feature')"
                      to="product-feature">
              <i class="lnr-select btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Características
            </t-button>
          </div>

          <div class="col-sm-4">
            <t-button class="btn-icon-vertical btn-square btn-transition btn btn-outline-primary"
                      :hasAccess="relationAccessPageGeneral('product-complement')"
                      to="product-complement">
              <i class="lnr-text-format btn-icon-wrapper btn-icon-lg mb-3"> </i>
              Acabamentos
            </t-button>
          </div>-->


        </div>
      </div>


    </t-page-general>

  </t-page>

</template>
<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import ui from "@/assets/scripts/ui";

export default {
  mixins: [pageDefaultMixin],
  name: 'ProductSettings',
  data() {
    return {

      //--------------------------------------------------------------------------------------
      //Início de campos personalizados desta tela
      accountModule: "",
      //--------------------------------------------------------------------------------------

    }
  },
  methods: {

    mountedPrepare() {

      this.accountModule = ui.getAccountModule()

    },
    async mountedContinued() {

    }
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela


    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedDefault()

    await this.mountedContinued()

  },
  computed: {},

}
</script>
